"use client";

import { useContentBodyController } from "./controller/useContentBodyController";
import ContentBodyView from "./view/ContentBodyView";
import type { ContentBodyInput } from "./model/contentBody.types";

export default function ContentBody(props: ContentBodyInput) {
  const viewModel = useContentBodyController(props);
  return <ContentBodyView {...viewModel} />;
}
